import React, { useState, useEffect, forwardRef } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box,
    Slide,
    DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector, useDispatch } from "react-redux";
import MultiSelectWithAll from "../../../../components/selections/multiSelectWithAll";
import { updateContactThunk } from "../../../contact/contactThunk";
import CustomButton from "../../../../components/buttons/customButton";
import SnackbarMessage from '../../../../components/snackBar/snackBar';
import { getLeadManagementThunk } from "../../leadMangementThunk";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function LeadAddBranchDeptModal({ show, handleClose, rowData }) {
    const dispatch = useDispatch();

    const { branchDepartments } = useSelector((state) => state.general);
    const [selectedBranchDeptIds, setSelectedBranchDeptIds] = useState([]);

    const { status } = useSelector((state) => state.contacts);

    const matchedBrachDept = branchDepartments.filter((item) => +rowData?.branch_department_id?.includes(+item.id)).map((item) => ({ value: item.id, label: item.branch_department_name }));

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    useEffect(() => {
        if (rowData && rowData !== undefined) {
            setSelectedBranchDeptIds(matchedBrachDept || [])
        }

        if (show === false) {
            setSelectedBranchDeptIds([]);
            setSnackbar({
                open: false,
                message: "",
                severity: "success",
            })
        }
    }, [rowData, show]);

    const handleMultiSelectChange = (_, selectedValues) => {
        setSelectedBranchDeptIds(selectedValues);
        setSnackbar({
            open: false,
            message: "",
            severity: "success",
        })
    };

    const handleSumit = async (e) => {
        e.preventDefault();

        const validations = [
            { valid: selectedBranchDeptIds.length > 0, message: "Brach Department is required", field: "selectedBranchDeptIds" },
        ];

        for (let rule of validations) {
            if (!rule.valid) {
                setSnackbar({
                    open: true,
                    message: rule.message,
                    severity: "error",
                });
                return;
            }
        }

        const payload1 = {
            "branch_department_id": selectedBranchDeptIds.map((item) => item.value).toString(''),
            "wa_contact_id": rowData?.wa_contact_id
        };

        try {
            const result = await dispatch(
                updateContactThunk({ credentials: payload1 })
            );

            if (result.meta.requestStatus === "fulfilled") {
                setSnackbar({
                    open: true,
                    message: result.payload.message,
                    severity: "success",
                });
                await dispatch(getLeadManagementThunk({ type: "getLeads" }));
                handleClose();
            } else {
                setSnackbar({
                    open: true,
                    message: result.payload,
                    severity: "error",
                });
            }
        } catch {
            setSnackbar({
                open: true,
                message: "Server error. Please try again.",
                severity: "error",
            });
        }
    };

    return (
        <Dialog
            open={show}
            onClose={handleClose}
            TransitionComponent={Transition}
            fullWidth
            maxWidth="xs"
            keepMounted
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    backgroundColor: "#fdfdfd",
                    boxShadow: 6,
                    mt: { xs: 2, sm: 4 },
                    mx: { xs: 1, sm: 4 },
                    width: { xs: "calc(100% - 16px)", sm: "calc(100% - 64px)" },
                    alignSelf: "flex-start",
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    bgcolor: "var(--primary)",
                    color: "#fff",
                    px: { xs: 2, sm: 3 },
                    py: 1,
                    borderTopLeftRadius: 12,
                    borderTopRightRadius: 12,
                }}
            >
                <DialogTitle sx={{ m: 0, p: 0, fontSize: "1.2rem" }}>
                    Select Branch Departments
                </DialogTitle>
                <IconButton onClick={handleClose} sx={{ color: "#fff" }}>
                    <CloseIcon />
                </IconButton>
            </Box>

            <DialogContent dividers>
                <MultiSelectWithAll
                    name="branchDepartments"
                    label="Branch Departments"
                    options={branchDepartments.map((item) => ({ value: item.id, label: item.branch_department_name })) || []}
                    value={selectedBranchDeptIds || []}
                    onChange={handleMultiSelectChange}
                    error={snackbar.message !== ""}
                    formHelperText={false}
                />
            </DialogContent>

            <DialogActions>
                <Box
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                    <CustomButton
                        status={status}
                        onClick={handleSumit}
                        label="Submit"
                        loadingLabel="Submitting.."
                    />
                </Box>
            </DialogActions>

            <SnackbarMessage
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            />
        </Dialog>
    );
}
